import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task02 } from "../../../../../task/course-04/lesson-07/task-02";

const task: Slide = {
  titleHtml: `The Sensitivity of a microphone is plotted below. Give its frequency range for<br /> a tolerance of ±2 dB relative to the nominal sensitivity at 1 kHz.`,
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/07/task/task-2-item-1.svg`,
                },
              },
              styles: {
                padding: "5%",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
